import './App.css';
import Home from './Template/Screen/Home';
import DriveYT from './Template/Screen/DriveYT';
import ClearBoxBuy from './Template/Screen/ClearBoxBuy';
import ClearBoxWorkingPrinciple from './Template/Screen/ClearBoxWorkingPrinciple';
import AboutScreen from './Template/Screen/About';
import PublicLayout from './Template/PublicLayout';
import ScrollToTop from './ScrollToTop';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

// ─── Admin imports ─────────────────────────────────────────────────
import { AuthProvider } from './admin/context/AuthContext';
import RequireAuth from './admin/components/RequireAuth';
import AdminLayout from './admin/components/AdminLayout';
import LoginPage from './admin/pages/LoginPage';
import ForgotPasswordPage from './admin/pages/ForgotPasswordPage';
import ResetPasswordPage from './admin/pages/ResetPasswordPage';
import RegisterPage from './admin/pages/RegisterPage';
import DashboardPage from './admin/pages/DashboardPage';
import ContactsPage from './admin/pages/ContactsPage';
import RfqsPage from './admin/pages/RfqsPage';
import ClearBoxConfigPage from './admin/pages/ClearBoxConfigPage';
import InviteAdminPage from './admin/pages/InviteAdminPage';
import AccountsPage from './admin/pages/AccountsPage';
import QuotesPage from './admin/pages/QuotesPage';

function App() {
  return (
    <AuthProvider>
    <Router>
    <ScrollToTop />
    <Routes>
      {/* ── Public routes (with Header / Footer) ──────────────── */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutScreen />} />
        <Route path="/projects/driveyt" element={<DriveYT />} />
        <Route path="/projects/clearbox-buy" element={<ClearBoxBuy />} />
        <Route path="/projects/clearbox-working-principle" element={<ClearBoxWorkingPrinciple />} />
      </Route>

      {/* ── Admin auth routes (no sidebar) ────────────────────── */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/admin/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/admin/register/:token" element={<RegisterPage />} />

      {/* ── Admin protected routes ────────────────────────────── */}
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="rfqs" element={<RfqsPage />} />
        <Route path="clearbox-config" element={<ClearBoxConfigPage />} />
        <Route path="quotes" element={<QuotesPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="accounts/invite" element={<InviteAdminPage />} />
      </Route>
    </Routes>
    </Router>
    </AuthProvider>
  );
}

export default App;
